var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initMainProduct = /* @__PURE__ */ __name(($formEl, $refs, productHandle, isProductBar = false) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q;
  let scrollContainer = $refs.scrollContainer;
  let gallery = $refs.gallery;
  let thumbnails = $refs.thumbnails;
  let init = true;
  const preorder_threshold = +((_a = window.theme_settings.data__product__variant__preorder_threshold) != null ? _a : 1);
  if (!scrollContainer) {
    scrollContainer = $formEl.querySelector(`[x-ref="scrollContainer"]`);
  }
  if (!gallery) {
    gallery = $formEl.querySelector(`[x-ref="gallery"]`);
  }
  if (!thumbnails) {
    thumbnails = $formEl.querySelector(`[x-ref="thumbnails"]`);
  }
  const cart = window.Alpine.store("cart");
  const isPrimary = !isProductBar && new RegExp(`^/products/${productHandle}`, "gi").test((_b = _stores == null ? void 0 : _stores.router) == null ? void 0 : _b.pathname);
  const quickView = $formEl.hasAttribute("data-quick-view");
  const settings = utils.JSONParse($formEl.getAttribute("data-settings"));
  const columnElements = [gallery, $refs == null ? void 0 : $refs.content, thumbnails].filter(Boolean);
  const product = utils.JSONParse(
    (_e = (_c = document.querySelector(`[data-primary-product-data="${productHandle}"]`)) == null ? void 0 : _c.innerHTML) != null ? _e : (_d = document.querySelector(`[data-product-data="${productHandle}"]`)) == null ? void 0 : _d.innerHTML
  );
  if (isPrimary) {
    const url = new URL(window.location.href);
    const variantId = url.searchParams.get("variant");
    product.selected_variant_id = variantId ? +variantId : product.selected_variant_id;
  }
  const selected_variant = ((_f = product == null ? void 0 : product.variants) == null ? void 0 : _f.find((v) => v.id === product.selected_variant_id)) || ((_g = product == null ? void 0 : product.variants) == null ? void 0 : _g.find(
    (v) => {
      var _a2;
      return v.id && ((_a2 = product.options_with_values) == null ? void 0 : _a2.every((option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]));
    }
  )) || ((_h = product == null ? void 0 : product.variants) == null ? void 0 : _h.find(
    (v) => {
      var _a2;
      return v.id && ((_a2 = product.options_with_values.slice(0, product.options_with_values.length - 1)) == null ? void 0 : _a2.every((option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]));
    }
  )) || (product.options_with_values.length >= 3 ? (_i = product == null ? void 0 : product.variants) == null ? void 0 : _i.find(
    (v) => {
      var _a2;
      return v.id && ((_a2 = product.options_with_values.slice(0, product.options_with_values.length - 2)) == null ? void 0 : _a2.every((option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]));
    }
  ) : null) || ((_j = product == null ? void 0 : product.variants) == null ? void 0 : _j.find(
    (v) => {
      var _a2;
      return v.id && ((_a2 = product.options_with_values) == null ? void 0 : _a2.some((option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]));
    }
  )) || ((_k = product == null ? void 0 : product.variants) == null ? void 0 : _k.find((v) => v.id === product.selected_or_first_available_variant_id)) || ((_l = product == null ? void 0 : product.variants) == null ? void 0 : _l[0]);
  const selling_plan_allocations = selected_variant == null ? void 0 : selected_variant.selling_plan_allocations;
  const selected_selling_plan = (_m = selling_plan_allocations == null ? void 0 : selling_plan_allocations[0]) == null ? void 0 : _m.selling_plan;
  const selling_plan_discount_wording = +((_o = (_n = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _n[0]) == null ? void 0 : _o.value) ? ((_q = (_p = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _p[0]) == null ? void 0 : _q.value_type) === "fixed_amount" ? `${utils.formatMoney((_s = (_r = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _r[0]) == null ? void 0 : _s.value)}` : ((_u = (_t = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _t[0]) == null ? void 0 : _u.value_type) === "percentage" ? `${(_w = (_v = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _v[0]) == null ? void 0 : _w.value}%` : "" : "";
  const gallerySettings = utils.JSONParse(gallery == null ? void 0 : gallery.getAttribute("data-settings"));
  const thumbnailSettings = utils.JSONParse(thumbnails == null ? void 0 : thumbnails.getAttribute("data-settings"));
  const mediaElements = [...(_x = gallery == null ? void 0 : gallery.querySelectorAll("[data-main-product-images] [data-media-id]")) != null ? _x : []].map((element) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
    return {
      element,
      mediaId: +element.getAttribute("data-media-id"),
      metafield: element.hasAttribute("data-metafield-media"),
      media: (_g2 = (_a2 = product == null ? void 0 : product.media) == null ? void 0 : _a2.find((media) => media.id === +element.getAttribute("data-media-id"))) != null ? _g2 : (_f2 = (_e2 = (_d2 = (_c2 = (_b2 = product == null ? void 0 : product.variants) == null ? void 0 : _b2.find((v) => {
        var _a3, _b3, _c3;
        return (_c3 = (_b3 = (_a3 = v.metafields) == null ? void 0 : _a3.smart) == null ? void 0 : _b3.images) == null ? void 0 : _c3.some((image) => image.id === +element.getAttribute("data-media-id"));
      })) == null ? void 0 : _c2.metafields) == null ? void 0 : _d2.smart) == null ? void 0 : _e2.images) == null ? void 0 : _f2.find((image) => image.id === +element.getAttribute("data-media-id"))
    };
  });
  const thumbnailMediaElements = [...(_y = thumbnails == null ? void 0 : thumbnails.querySelectorAll("[data-media-id]")) != null ? _y : []].map((element) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
    return {
      element,
      mediaId: +element.getAttribute("data-media-id"),
      metafield: element.hasAttribute("data-metafield-media"),
      media: (_g2 = (_a2 = product == null ? void 0 : product.media) == null ? void 0 : _a2.find((media) => media.id === +element.getAttribute("data-media-id"))) != null ? _g2 : (_f2 = (_e2 = (_d2 = (_c2 = (_b2 = product == null ? void 0 : product.variants) == null ? void 0 : _b2.find((v) => {
        var _a3, _b3, _c3;
        return (_c3 = (_b3 = (_a3 = v.metafields) == null ? void 0 : _a3.smart) == null ? void 0 : _b3.images) == null ? void 0 : _c3.some((image) => image.id === +element.getAttribute("data-media-id"));
      })) == null ? void 0 : _c2.metafields) == null ? void 0 : _d2.smart) == null ? void 0 : _e2.images) == null ? void 0 : _f2.find((image) => image.id === +element.getAttribute("data-media-id"))
    };
  });
  let discounted_price = selected_variant == null ? void 0 : selected_variant.price;
  const price_adjustment = (_E = (_z = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _z[0]) != null ? _E : (_D = (_C = (_B = (_A = selected_variant == null ? void 0 : selected_variant.selling_plan_allocations) == null ? void 0 : _A[0]) == null ? void 0 : _B.selling_plan) == null ? void 0 : _C.price_adjustments) == null ? void 0 : _D[0];
  if ((price_adjustment == null ? void 0 : price_adjustment.value_type) === "fixed_amount") {
    discounted_price = Math.max(discounted_price - Math.round(+(price_adjustment == null ? void 0 : price_adjustment.value)), 0);
  }
  if ((price_adjustment == null ? void 0 : price_adjustment.value_type) === "percentage") {
    discounted_price = Math.max(discounted_price - Math.round(+(price_adjustment == null ? void 0 : price_adjustment.value) / 100 * discounted_price), 0);
  }
  const available_quantity = (selected_variant == null ? void 0 : selected_variant.inventory_management) === "shopify" && (selected_variant == null ? void 0 : selected_variant.inventory_policy) === "deny" ? (selected_variant == null ? void 0 : selected_variant.inventory_quantity) - ((_G = (_F = cart == null ? void 0 : cart.state) == null ? void 0 : _F.items) == null ? void 0 : _G.reduce((acc, line) => line.variant_id === selected_variant.id ? acc + line.quantity : acc, 0)) : (selected_variant == null ? void 0 : selected_variant.preorder) && (selected_variant == null ? void 0 : selected_variant.preorder_quantity) ? (selected_variant == null ? void 0 : selected_variant.inventory_quantity) + (selected_variant == null ? void 0 : selected_variant.preorder_quantity) - ((_I = (_H = cart == null ? void 0 : cart.state) == null ? void 0 : _H.items) == null ? void 0 : _I.reduce((acc, line) => line.variant_id === selected_variant.id ? acc + line.quantity : acc, 0)) : 99999;
  const state = Alpine.reactive({
    element: $formEl,
    count: 0,
    manual_discount: 0,
    isPrimary,
    product,
    selected_media_id: (_K = (_J = product == null ? void 0 : product.media) == null ? void 0 : _J[0]) == null ? void 0 : _K.id,
    show_complementary_products: true,
    properties: {},
    selected_variant,
    selling_plan_allocations,
    selected_price: discounted_price,
    selected_compare_at_price: Math.max(selected_variant == null ? void 0 : selected_variant.compare_at_price, selected_variant == null ? void 0 : selected_variant.price),
    upsell_total: 0,
    upsell_compare_at_total: 0,
    selected_selling_plan: null,
    last_selected_selling_plan: selected_selling_plan,
    selling_plan_discount_wording,
    isAdding: false,
    dynamic_buy_button: null,
    options: selected_variant == null ? void 0 : selected_variant.options,
    quantity: 1,
    quantity_limit: available_quantity,
    sibling_handle: "",
    disable_add_to_cart: /* @__PURE__ */ new Set(),
    hasVariants: ((_L = product == null ? void 0 : product.variants) == null ? void 0 : _L.length) > 1 || ((_N = (_M = product == null ? void 0 : product.variants) == null ? void 0 : _M[0]) == null ? void 0 : _N.title) !== "Default Title",
    hasSubscription: !!((_O = selected_variant == null ? void 0 : selected_variant.options) == null ? void 0 : _O.length),
    soldOut: available_quantity <= 0,
    available_quantity,
    preorder: (selected_variant == null ? void 0 : selected_variant.preorder) && (selected_variant == null ? void 0 : selected_variant.inventory_quantity) - ((_Q = (_P = cart == null ? void 0 : cart.state) == null ? void 0 : _P.items) == null ? void 0 : _Q.reduce((acc, line) => line.variant_id === selected_variant.id ? acc + line.quantity : acc, 0)) < preorder_threshold,
    upsell_items: /* @__PURE__ */ new Map()
  });
  const handlePopState = /* @__PURE__ */ __name((e) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2;
    const url = new URL(window.location.href);
    const selling_plan_id = +url.searchParams.get("selling_plan");
    const variant_id = +url.searchParams.get("variant");
    if (!variant_id) return;
    if (((_a2 = state.selected_variant) == null ? void 0 : _a2.id) !== variant_id) {
      state.selected_variant = (_d2 = (_c2 = (_b2 = state.product) == null ? void 0 : _b2.variants) == null ? void 0 : _c2.find((variant) => variant.id === variant_id)) != null ? _d2 : state.selected_variant;
      state.options = (_e2 = state.selected_variant) == null ? void 0 : _e2.options;
    }
    if (selling_plan_id !== ((_f2 = state.selected_selling_plan) == null ? void 0 : _f2.id)) {
      state.selected_selling_plan = (_j2 = (_i2 = (_h2 = (_g2 = state.selected_variant) == null ? void 0 : _g2.selling_plan_allocations) == null ? void 0 : _h2.find((plan) => plan.selling_plan.id === selling_plan_id)) == null ? void 0 : _i2.selling_plan) != null ? _j2 : state.selected_selling_plan;
    }
  }, "handlePopState");
  const styleDynamicBuyButton = /* @__PURE__ */ __name((element) => {
    var _a2, _b2;
    const cssClass = element.getAttribute("data-button-class");
    const previewButton = element.querySelector("[data-pre-styled-button]");
    element.style.setProperty("--shopify-accelerated-checkout-button-block-size", (_a2 = getComputedStyle(previewButton)) == null ? void 0 : _a2.height);
    element.style.setProperty(
      "--shopify-accelerated-checkout-button-border-radius",
      (_b2 = getComputedStyle(previewButton)) == null ? void 0 : _b2.borderRadius
    );
    previewButton.remove();
  }, "styleDynamicBuyButton");
  const handleAddToCart = /* @__PURE__ */ __name(async (e) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2;
    if (state.disable_add_to_cart.size > 0) return;
    e.preventDefault();
    e.stopPropagation();
    const random_id = utils.shortUUID();
    const properties = {};
    if (state.upsell_items.size && ((_a2 = [...state.upsell_items.values()]) == null ? void 0 : _a2.some((item) => item.bundle))) {
      properties["_p_id"] = `${random_id}`;
    }
    if (((_b2 = state.selected_variant) == null ? void 0 : _b2.preorder) && ((_c2 = state.selected_variant) == null ? void 0 : _c2.inventory_quantity) < preorder_threshold) {
      properties["Preorder"] = `true`;
      if ((_d2 = state.selected_variant) == null ? void 0 : _d2.preorder_date) {
        properties["Preorder"] = `Shipping ${new Date(state.selected_variant.preorder_date).toLocaleDateString(
          navigator.language,
          {
            month: "short",
            year: "numeric"
          }
        )}`;
      }
    }
    const formElement = $formEl.tagName === "FORM" ? $formEl : document.querySelector(`form[data-handle="${(_f2 = (_e2 = state.product) == null ? void 0 : _e2.handle) != null ? _f2 : productHandle}"]`);
    if (formElement.tagName === "FORM") {
      (_g2 = Object.entries(utils.serializeForm(formElement))) == null ? void 0 : _g2.forEach(([key, value]) => {
        if (key.includes("properties[") && value) {
          properties[key.replace(/^properties\[(.*)]$/gi, "$1")] = value;
        }
      });
    }
    state.isAdding = true;
    const data = await _cart.add({
      items: [
        {
          id: state.selected_variant.id,
          quantity: state.quantity,
          selling_plan: cart.global_subscriptions ? (_k2 = (_j2 = (_i2 = (_h2 = state.selected_variant) == null ? void 0 : _h2.selling_plan_allocations) == null ? void 0 : _i2.find(
            (plan) => {
              var _a3;
              return ((_a3 = plan.selling_plan) == null ? void 0 : _a3.id) === cart.cart_selling_plan_id;
            }
          )) == null ? void 0 : _j2.selling_plan) == null ? void 0 : _k2.id : (_l2 = state.selected_selling_plan) == null ? void 0 : _l2.id,
          properties: {
            ...properties,
            ...state.properties
          }
        },
        ...[...state.upsell_items.values()].map((entry) => {
          var _a3, _b3, _c3, _d3, _e3, _f3, _g3, _h3, _i3, _j3, _k3;
          return {
            id: entry.id,
            selling_plan: cart.global_subscriptions ? (_d3 = (_c3 = (_b3 = (_a3 = state.selected_variant) == null ? void 0 : _a3.selling_plan_allocations) == null ? void 0 : _b3.find(
              (plan) => {
                var _a4;
                return ((_a4 = plan.selling_plan) == null ? void 0 : _a4.id) === cart.cart_selling_plan_id;
              }
            )) == null ? void 0 : _c3.selling_plan) == null ? void 0 : _d3.id : (_h3 = (_g3 = (_f3 = (_e3 = entry.variant) == null ? void 0 : _e3.selling_plan_allocations) == null ? void 0 : _f3.find((plan) => {
              var _a4, _b4;
              return ((_a4 = plan.selling_plan) == null ? void 0 : _a4.id) === ((_b4 = state.selected_selling_plan) == null ? void 0 : _b4.id);
            })) == null ? void 0 : _g3.selling_plan) == null ? void 0 : _h3.id,
            quantity: state.quantity * entry.quantity,
            properties: {
              ...entry.properties,
              _p_id_link: (entry == null ? void 0 : entry.bundle) ? `${random_id}` : void 0,
              _p_required: (entry == null ? void 0 : entry.auto_addon) ? "true" : void 0,
              _p_fixed_quantity: !(entry == null ? void 0 : entry.variable_quantity) ? "true" : void 0,
              Preorder: ((_i3 = entry == null ? void 0 : entry.variant) == null ? void 0 : _i3.preorder) && ((_j3 = entry == null ? void 0 : entry.variant) == null ? void 0 : _j3.inventory_quantity) < preorder_threshold ? ((_k3 = entry == null ? void 0 : entry.variant) == null ? void 0 : _k3.preorder_date) ? `Shipping ${new Date(entry == null ? void 0 : entry.variant.preorder_date).toLocaleDateString(navigator.language, {
                month: "short",
                year: "numeric"
              })}` : "true" : void 0
            }
          };
        })
      ]
    });
    state.isAdding = false;
    if (!data.cart_error) {
      _stores.modal.setId("modal--cart-drawer");
      _stores.quickView.show = false;
    }
  }, "handleAddToCart");
  const handleBackInStockNotification = /* @__PURE__ */ __name(async (e) => {
    var _a2;
    if ((_a2 = state == null ? void 0 : state.selected_variant) == null ? void 0 : _a2.available) return;
    e.preventDefault();
    e.stopPropagation();
    _stores.modal.setId("back_in_stock");
    _stores.backInStockNotification.product = state.product;
    _stores.backInStockNotification.selected_variant = state.selected_variant;
  }, "handleBackInStockNotification");
  const setSelectedVariant = /* @__PURE__ */ __name((id, scroll_to_variant = true) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2, _q2, _r2, _s2, _t2, _u2, _v2;
    state.selected_variant = (_a2 = state.product.variants) == null ? void 0 : _a2.find((variant) => variant.id === id);
    state.options = (_b2 = state.selected_variant) == null ? void 0 : _b2.options;
    if (state.selected_selling_plan && !((_d2 = (_c2 = state.selected_variant) == null ? void 0 : _c2.selling_plan_allocations) == null ? void 0 : _d2.some(
      (plan) => {
        var _a3, _b3;
        return ((_a3 = plan == null ? void 0 : plan.selling_plan) == null ? void 0 : _a3.id) === ((_b3 = state.selected_selling_plan) == null ? void 0 : _b3.id);
      }
    ))) {
      state.selected_selling_plan = (_h2 = (_g2 = (_f2 = (_e2 = state.selected_variant) == null ? void 0 : _e2.selling_plan_allocations) == null ? void 0 : _f2[0]) == null ? void 0 : _g2.selling_plan) != null ? _h2 : null;
    }
    if (state.product.requires_selling_plan && !state.selected_selling_plan) {
      state.selected_selling_plan = (_o2 = (_k2 = (_j2 = (_i2 = state.selected_variant) == null ? void 0 : _i2.selling_plan_allocations) == null ? void 0 : _j2[0]) == null ? void 0 : _k2.selling_plan) != null ? _o2 : (_n2 = (_m2 = (_l2 = state.product.selling_plan_groups) == null ? void 0 : _l2[0]) == null ? void 0 : _m2.selling_plans) == null ? void 0 : _n2[0];
    }
    if ((gallerySettings == null ? void 0 : gallerySettings.scroll_to_selected_variant_image) && ((_q2 = (_p2 = state.selected_variant) == null ? void 0 : _p2.featured_media) == null ? void 0 : _q2.id) && scroll_to_variant) {
      scrollToMediaById((_s2 = (_r2 = state.selected_variant) == null ? void 0 : _r2.featured_media) == null ? void 0 : _s2.id, false);
    }
    _product.lastOptions = {
      ...(_t2 = _product.lastOptions) != null ? _t2 : {},
      ...(_v2 = (_u2 = state.product.options_with_values) == null ? void 0 : _u2.reduce((acc, option, index) => {
        acc[utils.handlelize(option == null ? void 0 : option.name)] = state.options[index];
        return acc;
      }, {})) != null ? _v2 : {}
    };
  }, "setSelectedVariant");
  const setProductOption = /* @__PURE__ */ __name(({ index, value }) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2;
    const options = [...state.options];
    options[index] = value;
    setSelectedVariant(
      (_o2 = (_k2 = (_g2 = (_c2 = (_b2 = (_a2 = state.product) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.find((variant) => variant.options.every((option, i) => options[i] === option))) == null ? void 0 : _c2.id) != null ? _g2 : (_f2 = (_e2 = (_d2 = state.product) == null ? void 0 : _d2.variants) == null ? void 0 : _e2.find((variant) => variant.options[index] === value)) == null ? void 0 : _f2.id) != null ? _k2 : (_j2 = (_i2 = (_h2 = state.product) == null ? void 0 : _h2.variants) == null ? void 0 : _i2.find(({ available }) => available)) == null ? void 0 : _j2.id) != null ? _o2 : (_n2 = (_m2 = (_l2 = state.product) == null ? void 0 : _l2.variants) == null ? void 0 : _m2[0]) == null ? void 0 : _n2.id
    );
  }, "setProductOption");
  const setSellingPlan = /* @__PURE__ */ __name((selling_plan_id) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2;
    state.selected_selling_plan = (_a2 = state.selling_plan_allocations.find(
      (allocation) => allocation.selling_plan.id === selling_plan_id
    )) == null ? void 0 : _a2.selling_plan;
    if (state.selected_selling_plan) {
      state.last_selected_selling_plan = state.selected_selling_plan;
    }
    const selling_plan = (_c2 = state.selected_selling_plan) != null ? _c2 : (_b2 = selling_plan_allocations == null ? void 0 : selling_plan_allocations[0]) == null ? void 0 : _b2.selling_plan;
    state.selling_plan_discount_wording = ((_e2 = (_d2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _d2[0]) == null ? void 0 : _e2.value) ? ((_g2 = (_f2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _f2[0]) == null ? void 0 : _g2.value_type) === "fixed_amount" ? `${utils.formatMoney((_i2 = (_h2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _h2[0]) == null ? void 0 : _i2.value)}` : ((_k2 = (_j2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _j2[0]) == null ? void 0 : _k2.value_type) === "percentage" ? `${(_m2 = (_l2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _l2[0]) == null ? void 0 : _m2.value}%` : "" : "";
  }, "setSellingPlan");
  const setSiblingProduct = /* @__PURE__ */ __name((handle, quickView2) => {
    var _a2, _b2, _c2;
    if (handle === state.product.handle) return;
    _product.lastOptions = {
      ...(_a2 = _product.lastOptions) != null ? _a2 : {},
      ...(_c2 = (_b2 = state.product.options_with_values) == null ? void 0 : _b2.reduce((acc, option, index) => {
        acc[utils.handlelize(option == null ? void 0 : option.name)] = state.options[index];
        return acc;
      }, {})) != null ? _c2 : {}
    };
    if (quickView2) {
      _stores.quickView.renderQuickView(handle);
      return;
    }
    window.location.assign(utils.getSiblingUrl(handle));
  }, "setSiblingProduct");
  const setQuantity = /* @__PURE__ */ __name((quantity) => {
    state.quantity = quantity;
  }, "setQuantity");
  const handleStickyScroll = /* @__PURE__ */ __name(() => {
  }, "handleStickyScroll");
  const scrollToMediaById = /* @__PURE__ */ __name(async (mediaId, no_variant_select = true) => {
    var _a2, _b2, _c2, _d2;
    const isHorizontal = /* @__PURE__ */ __name(() => {
      return !!(getComputedStyle(scrollContainer).overflowY === "hidden" || getComputedStyle(scrollContainer).gridAutoFlow === "column" || scrollContainer.scrollWidth > (scrollContainer == null ? void 0 : scrollContainer.clientWidth));
    }, "isHorizontal");
    const image = gallery == null ? void 0 : gallery.querySelector(`[data-media-id="${mediaId}"]`);
    if ((thumbnailSettings == null ? void 0 : thumbnailSettings.select_variant_on_click) && no_variant_select) {
      setSelectedVariant(
        ((_a2 = state.product.variants.find((v) => {
          var _a3;
          return ((_a3 = v.featured_media) == null ? void 0 : _a3.id) === mediaId;
        })) == null ? void 0 : _a2.id) || ((_b2 = state.selected_variant) == null ? void 0 : _b2.id),
        false
      );
    }
    if (!image) return;
    await utils.delay(5);
    const header = document.querySelector(".header-sections-container");
    const offsetHeight = Math.max(180, (_d2 = (_c2 = header == null ? void 0 : header.getBoundingClientRect()) == null ? void 0 : _c2.bottom) != null ? _d2 : 0);
    const imageOffset = utils.getElementPosition(image);
    if (utils.isElementScrollable(scrollContainer)) {
      let scrollSnap = false;
      if (["snap-both", "snap-x", "snap-y"].some((c) => {
        var _a3;
        return (_a3 = scrollContainer == null ? void 0 : scrollContainer.classList) == null ? void 0 : _a3.contains(c);
      })) {
        scrollContainer == null ? void 0 : scrollContainer.classList.remove("snap-both", "snap-x", "snap-y");
        scrollSnap = true;
      }
      utils.scrollToXY(200, image.offsetLeft, image.offsetTop, scrollContainer, () => {
        if (scrollSnap) {
          scrollContainer == null ? void 0 : scrollContainer.classList.add(isHorizontal() ? "snap-x" : "snap-y");
        }
        state.selected_media_id = mediaId;
      });
    } else {
      utils.scrollToXY(
        200,
        image.offsetLeft,
        imageOffset.top - offsetHeight - +getComputedStyle(gallery).paddingTop.replace("px", ""),
        window,
        () => {
          state.selected_media_id = mediaId;
        }
      );
    }
  }, "scrollToMediaById");
  const renderProductCards = /* @__PURE__ */ __name(async (element, primary_source, secondary_source, product_class, desktop_display_limit, mobile_display_limit) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2;
    const limit = Math.max(desktop_display_limit, mobile_display_limit);
    const fallback_products = utils.JSONParse(element.getAttribute("data-fallback-products"));
    const products = [];
    switch (primary_source) {
      case "complementary": {
        (_b2 = (_a2 = state.product) == null ? void 0 : _a2.complementary_products) == null ? void 0 : _b2.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "related": {
        (_d2 = (_c2 = state.product) == null ? void 0 : _c2.related_products) == null ? void 0 : _d2.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "recently_viewed": {
        const recent_products = await Promise.all(
          (_f2 = (_e2 = window == null ? void 0 : window._recent_products) != null ? _e2 : []) == null ? void 0 : _f2.map(([handle, product_id]) => _product.getHydratedProductData(handle, product_id))
        );
        recent_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "manual": {
        fallback_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
    }
    switch (secondary_source) {
      case "complementary": {
        (_h2 = (_g2 = state.product) == null ? void 0 : _g2.complementary_products) == null ? void 0 : _h2.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "related": {
        (_j2 = (_i2 = state.product) == null ? void 0 : _i2.related_products) == null ? void 0 : _j2.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "recently_viewed": {
        const recent_products = await Promise.all(
          ((_k2 = window == null ? void 0 : window._recent_products) != null ? _k2 : []).map(([handle, product_id]) => _product.getHydratedProductData(handle, product_id))
        );
        recent_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "manual": {
        break;
      }
    }
    const renderProducts = (_o2 = (_n2 = (_m2 = (_l2 = products == null ? void 0 : products.filter((prod) => prod && prod.id !== state.product.id)) == null ? void 0 : _l2.filter((a, i, arr) => arr.findIndex((b) => b.id === a.id) === i)) == null ? void 0 : _m2.filter((prod, index) => {
      var _a3, _b3;
      return prod.handle !== ((_b3 = (_a3 = element.children) == null ? void 0 : _a3[index]) == null ? void 0 : _b3.getAttribute("data-product-handle"));
    })) == null ? void 0 : _n2.slice(0, limit)) != null ? _o2 : [];
    if (!renderProducts.length) {
      return;
    }
    const nonProductElements = element.querySelectorAll(":scope > :not([data-product-handle])");
    element.innerHTML = "";
    nonProductElements.forEach((el) => {
      element.appendChild(el);
    });
    renderProducts.forEach((prod, i, arr) => {
      var _a3;
      const node = (_a3 = document.querySelector(`[data-product-card='${product_class}']`)) == null ? void 0 : _a3.cloneNode(true);
      if (node) {
        const div = document.createElement("div");
        div.setAttribute("data-product-handle", prod.handle);
        div.setAttribute(
          "class",
          `shrink-0 max-w-full w-full h-full order-[--order] ${i > desktop_display_limit ? "mobile-only" : i > mobile_display_limit ? "desktop-tablet-only" : ""}`
        );
        div.style.setProperty("--order", `${(i + 1) * 10}`);
        node.removeAttribute(`data-product-card`);
        node.setAttribute("data-product-handle", prod.handle);
        node.setAttribute("data-product-id", prod.id);
        node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
          el.remove();
        });
        div.appendChild(node);
        element.appendChild(div);
      }
    });
  }, "renderProductCards");
  const handleImageSelection = /* @__PURE__ */ __name((filter_images, items, variant) => {
    switch (filter_images) {
      case "show_all_variants": {
        items == null ? void 0 : items.forEach(({ element, mediaId }) => {
          element.classList.toggle("hidden", !state.product.variants.some((v) => {
            var _a2;
            return ((_a2 = v == null ? void 0 : v.featured_media) == null ? void 0 : _a2.id) === mediaId;
          }));
        });
        return;
      }
      case "show_all": {
        items == null ? void 0 : items.forEach(({ element, mediaId }) => element.classList.remove("hidden"));
        return;
      }
      case "selected_variant": {
        items == null ? void 0 : items.forEach(({ element, mediaId }) => {
          var _a2;
          element.classList.toggle("hidden", ((_a2 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _a2.id) !== mediaId);
        });
        return;
      }
      case "variant_images_by_order": {
        let hide = true;
        items == null ? void 0 : items.forEach(({ element, mediaId }) => {
          var _a2;
          if (((_a2 = variant.featured_media) == null ? void 0 : _a2.id) === mediaId || variant.featured_media === null) {
            hide = false;
            element.classList.toggle("hidden", hide);
            return;
          }
          if (state.product.variants.map((v) => {
            var _a3;
            return (_a3 = v == null ? void 0 : v.featured_media) == null ? void 0 : _a3.id;
          }).includes(mediaId)) {
            hide = true;
          }
          element.classList.toggle("hidden", hide);
        });
        return;
      }
      case "variant_images_by_metafield": {
        items == null ? void 0 : items.forEach(({ element, mediaId, metafield }) => {
          var _a2, _b2, _c2, _d2, _e2, _f2;
          const show = ((_a2 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _a2.id) === mediaId || ((_e2 = (_d2 = (_c2 = (_b2 = state.selected_variant) == null ? void 0 : _b2.metafields) == null ? void 0 : _c2.smart) == null ? void 0 : _d2.images) == null ? void 0 : _e2.some((m) => m.id === mediaId));
          element.classList.toggle("hidden", !show);
          element.classList.toggle("order-first", ((_f2 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _f2.id) === mediaId);
        });
        return;
      }
      case "variant_images_and_unassigned": {
        items == null ? void 0 : items.forEach(({ element, mediaId }) => {
          var _a2, _b2;
          const show = ((_a2 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _a2.id) === mediaId || !state.product.variants.map((v) => {
            var _a3;
            return (_a3 = v == null ? void 0 : v.featured_media) == null ? void 0 : _a3.id;
          }).includes(mediaId);
          element.classList.toggle("hidden", !show);
          element.classList.toggle("order-first", ((_b2 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _b2.id) === mediaId);
        });
        return;
      }
      case "only_unassigned": {
        items == null ? void 0 : items.forEach(({ element, mediaId }) => {
          const show = !state.product.variants.map((v) => {
            var _a2;
            return (_a2 = v == null ? void 0 : v.featured_media) == null ? void 0 : _a2.id;
          }).includes(mediaId);
          element.classList.toggle("hidden", !show);
        });
        return;
      }
      case "first_or_selected_image": {
        items == null ? void 0 : items.forEach(({ element, mediaId }) => {
          element.classList.toggle("hidden", state.selected_media_id !== mediaId);
        });
        return;
      }
    }
  }, "handleImageSelection");
  const atlasSecondaryRoleOrder = /* @__PURE__ */ __name((media) => {
    const alt = `${(media == null ? void 0 : media.alt) || ""}`.toLowerCase();
    if (alt.includes("box back") || alt.includes("carton back") || alt.includes("pack back")) return 1;
    if (alt.includes("real ingredients compared") || alt.includes("dark chocolate almond atlas bar with almonds")) return 2;
    if (alt.includes("atlas dark chocolate almond bar on a dark chocolate background")) return 3;
    if (alt.includes("background") || alt.includes("variety pack contents") || alt.includes("with chocolate and sea salt")) return 3;
    if (alt.includes("clinical study chart")) return 4;
    return 0;
  }, "atlasSecondaryRoleOrder");
  const hydrateAtlasSecondaryImage = /* @__PURE__ */ __name((element) => {
    element.querySelectorAll("source[data-srcset]").forEach((source) => {
      source.srcset = source.dataset.srcset;
    });
    const image = element.querySelector("img");
    if (!image) return;
    image.loading = "eager";
    image.fetchPriority = "low";
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.src) image.src = image.dataset.src;
  }, "hydrateAtlasSecondaryImage");
  const syncAtlasMediaLayout = /* @__PURE__ */ __name(() => {
    if (!gallery) return;
    const visibleMediaIds = mediaElements.filter(({ element }) => !element.classList.contains("hidden") && !element.classList.contains("!hidden")).map(({ mediaId }) => mediaId);
    mediaElements.forEach(({ element, mediaId }) => {
      element.classList.toggle("atlas-layout-hidden", visibleMediaIds.indexOf(mediaId) !== 0);
    });
    const selectedFlavor = `${state.selected_variant?.options?.[state.selected_variant.options.length - 1] || state.selected_variant?.title || ""}`.toLowerCase();
    const secondaryItems = [...gallery.querySelectorAll("[data-atlas-secondary-media-id]:not([data-atlas-dca-clinical-item])")].map((element) => {
      const mediaId = +element.getAttribute("data-atlas-secondary-media-id");
      const media = state.product.media.find((item) => item.id === mediaId);
      const roleOrder = atlasSecondaryRoleOrder(media);
      if (!element.dataset.atlasOriginalMediaMarkup) {
        element.dataset.atlasOriginalMediaMarkup = element.innerHTML;
      } else {
        element.innerHTML = element.dataset.atlasOriginalMediaMarkup;
      }
      return { element, mediaId, media, roleOrder };
    });
    const selectedByRole = new Map();
    [1, 2, 3, 4].forEach((roleOrder) => {
      let candidates = secondaryItems.filter(({ mediaId, roleOrder: itemRole }) => visibleMediaIds.includes(mediaId) && itemRole === roleOrder);
      if (selectedFlavor.includes("chocolate peanut butter") && roleOrder === 3) {
        candidates = secondaryItems.filter(({ media }) => `${(media == null ? void 0 : media.alt) || ""}`.toLowerCase().includes("chocolate peanut butter bar on a chocolate peanut butter background"));
      }
      if (!candidates.length) return;
      let flavorMatch = candidates.find(({ media }) => `${media?.alt || ""}`.toLowerCase().includes(selectedFlavor));
      selectedByRole.set(roleOrder, flavorMatch || candidates[0]);
    });
    const selectedRoleByElement = new Map([...selectedByRole].map(([selectedRole, item]) => [item.element, selectedRole]));
    secondaryItems.forEach(({ element, roleOrder }) => {
      const selectedRole = selectedRoleByElement.get(element);
      const isSelected = selectedRole != null;
      element.classList.toggle("atlas-secondary-hidden", !isSelected);
      if (isSelected) {
        hydrateAtlasSecondaryImage(element);
      }
      const displayRoleOrder = selectedRole ?? roleOrder;
      if (displayRoleOrder > 0) {
        element.style.setProperty("--atlas-media-order", `${displayRoleOrder}`);
      }
    });
    const featuredMediaId = state.selected_variant?.featured_media?.id || visibleMediaIds[0];
    const thumbnailRoleByMediaId = new Map(
      [...selectedByRole].map(([selectedRole, item]) => [item.mediaId, selectedRole])
    );
    const selectedThumbnailIds = new Set([featuredMediaId, ...thumbnailRoleByMediaId.keys()]);
    thumbnails?.querySelectorAll("[data-media-id]").forEach((element) => {
      const mediaId = +element.getAttribute("data-media-id");
      const selectedRole = thumbnailRoleByMediaId.get(mediaId);
      element.classList.toggle("hidden", !selectedThumbnailIds.has(mediaId));
      const thumbnailOrder = mediaId === featuredMediaId ? 0 : selectedRole === 1 ? 1 : selectedRole === 2 ? 2 : selectedRole === 4 ? 3 : selectedRole === 3 ? 4 : 99;
      element.style.order = `${thumbnailOrder}`;
    });
    gallery.querySelectorAll("[data-atlas-dca-clinical-item]").forEach((item) => item.remove());
  }, "syncAtlasMediaLayout");
  const showAtlasImageZoom = /* @__PURE__ */ __name((mediaItems, initialIndex = 0) => {
    const imageMedia = (Array.isArray(mediaItems) ? mediaItems : [mediaItems]).filter(
      (media) => (media == null ? void 0 : media.src) && (!(media == null ? void 0 : media.media_type) || media.media_type === "image")
    );
    if (!imageMedia.length) return;
    let dialog = document.querySelector("[data-atlas-image-zoom]");
    if (!dialog) {
      dialog = document.createElement("dialog");
      dialog.setAttribute("data-atlas-image-zoom", "");
      dialog.setAttribute("aria-label", "Product image preview");
      dialog.innerHTML = `
        <button type="button" data-atlas-image-zoom-backdrop aria-label="Close image preview"></button>
        <button type="button" data-atlas-image-zoom-close aria-label="Close image preview"><span></span><span></span></button>
        <div data-atlas-image-zoom-stage>
          <img data-atlas-image-zoom-image alt="">
        </div>
        <div data-atlas-image-zoom-thumbnails aria-label="Product images"></div>
      `;
      const style = document.createElement("style");
      style.textContent = `
        [data-atlas-image-zoom] {
          align-items: center;
          background: transparent;
          border: 0;
          display: none;
          flex-direction: column;
          height: 100dvh;
          justify-content: center;
          margin: 0;
          max-height: none;
          max-width: none;
          overflow: hidden;
          padding: max(72px, env(safe-area-inset-top)) 8px max(24px, env(safe-area-inset-bottom));
          width: 100vw;
        }
        [data-atlas-image-zoom][open] { display: flex; }
        [data-atlas-image-zoom]::backdrop { background: transparent; }
        [data-atlas-image-zoom-backdrop] {
          background: #000;
          border: 0;
          cursor: zoom-out;
          inset: 0;
          opacity: .8;
          padding: 0;
          position: fixed;
        }
        [data-atlas-image-zoom-stage] {
          align-items: center;
          background: transparent;
          border-radius: 24px;
          display: flex;
          justify-content: center;
          max-height: calc(100dvh - 190px);
          max-width: min(720px, calc(100vw - 16px));
          overflow: hidden;
          position: relative;
          width: fit-content;
          z-index: 1;
        }
        [data-atlas-image-zoom-image] {
          display: block;
          height: auto;
          max-height: calc(100dvh - 190px);
          max-width: 100%;
          object-fit: contain;
          border-radius: 24px;
          width: auto;
        }
        [data-atlas-image-zoom-image][data-atlas-canvas-blend="true"] {
          mix-blend-mode: multiply;
        }
        [data-atlas-image-zoom-close] {
          background: transparent;
          border: 0;
          cursor: pointer;
          height: 32px;
          padding: 0;
          position: fixed;
          right: 24px;
          top: max(24px, env(safe-area-inset-top));
          width: 32px;
          z-index: 2;
        }
        [data-atlas-image-zoom-close] span {
          background: #fff;
          height: 1.5px;
          left: 4px;
          position: absolute;
          top: 15px;
          transform: rotate(45deg);
          width: 24px;
        }
        [data-atlas-image-zoom-close] span + span { transform: rotate(-45deg); }
        [data-atlas-image-zoom-thumbnails] {
          display: flex;
          gap: 8px;
          justify-content: center;
          margin-top: 20px;
          max-width: calc(100vw - 24px);
          overflow-x: auto;
          padding: 0 2px 2px;
          scrollbar-width: none;
          z-index: 1;
        }
        [data-atlas-image-zoom-thumbnails]::-webkit-scrollbar { display: none; }
        [data-atlas-image-zoom-thumbnail] {
          background: #f3f3f3;
          border: 2px solid transparent;
          border-radius: 8px;
          cursor: pointer;
          flex: 0 0 56px;
          height: 56px;
          overflow: hidden;
          padding: 0;
        }
        [data-atlas-image-zoom-thumbnail][aria-current="true"] { border-color: #fff; }
        [data-atlas-image-zoom-thumbnail] img {
          display: block;
          height: 100%;
          object-fit: cover;
          width: 100%;
        }
        @media (min-width: 750px) {
          [data-atlas-image-zoom] { padding-left: 32px; padding-right: 32px; }
          [data-atlas-image-zoom-stage] { max-width: min(760px, calc(100vw - 64px)); }
          [data-atlas-image-zoom-thumbnail] { flex-basis: 68px; height: 68px; }
          [data-atlas-image-zoom-thumbnails] { gap: 10px; }
        }
        @media (prefers-reduced-motion: no-preference) {
          [data-atlas-image-zoom-image] { animation: atlas-image-zoom-in 160ms ease-out; }
          @keyframes atlas-image-zoom-in {
            from { opacity: 0; transform: scale(.985); }
            to { opacity: 1; transform: scale(1); }
          }
        }
      `;
      document.head.appendChild(style);
      document.body.appendChild(dialog);
      dialog.querySelector("[data-atlas-image-zoom-close]").addEventListener("click", () => dialog.close());
      dialog.querySelector("[data-atlas-image-zoom-backdrop]").addEventListener("click", () => dialog.close());
      dialog.addEventListener("close", () => {
        var _a2;
        (_a2 = dialog.atlasImageZoomTrigger) == null ? void 0 : _a2.focus({ preventScroll: true });
      });
    }
    const image = dialog.querySelector("[data-atlas-image-zoom-image]");
    const thumbnails = dialog.querySelector("[data-atlas-image-zoom-thumbnails]");
    const normalizeSrc = /* @__PURE__ */ __name((src) => src.startsWith("//") ? `https:${src}` : src, "normalizeSrc");
    const selectImage = /* @__PURE__ */ __name((index) => {
      const selected = imageMedia[index] || imageMedia[0];
      image.src = normalizeSrc(selected.src);
      image.alt = selected.alt || "Atlas product image";
      image.setAttribute("data-atlas-canvas-blend", /(?:box|carton) back/i.test(image.alt) ? "true" : "false");
      thumbnails.querySelectorAll("[data-atlas-image-zoom-thumbnail]").forEach((thumbnail, thumbnailIndex) => {
        thumbnail.setAttribute("aria-current", thumbnailIndex === index ? "true" : "false");
      });
    }, "selectImage");
    thumbnails.innerHTML = "";
    imageMedia.forEach((item, index) => {
      const thumbnail = document.createElement("button");
      thumbnail.type = "button";
      thumbnail.setAttribute("data-atlas-image-zoom-thumbnail", "");
      thumbnail.setAttribute("aria-label", `View product image ${index + 1}`);
      thumbnail.innerHTML = `<img src="${normalizeSrc(item.src)}" alt="" loading="lazy" decoding="async">`;
      thumbnail.addEventListener("click", () => selectImage(index));
      thumbnails.appendChild(thumbnail);
    });
    const safeInitialIndex = Math.max(0, Math.min(initialIndex, imageMedia.length - 1));
    selectImage(safeInitialIndex);
    dialog.atlasImageZoomTrigger = document.activeElement;
    if (!dialog.open) dialog.showModal();
  }, "showAtlasImageZoom");
  const showMediaGallery = /* @__PURE__ */ __name((mediaId) => {
    var _a2, _b2;
    const atlasVisibleMediaIds = new Set(
      [...(gallery == null ? void 0 : gallery.querySelectorAll("[data-atlas-secondary-media-id]:not(.atlas-secondary-hidden)")) || []].map(
        (item) => +item.getAttribute("data-atlas-secondary-media-id")
      )
    );
    const rawMediaItems = (_b2 = (_a2 = mediaElements == null ? void 0 : mediaElements.filter(
      (item) => {
        var _a3, _b3, _c2;
        return (((_a3 = getComputedStyle(item.element)) == null ? void 0 : _a3.display) !== "none" || ((_c2 = getComputedStyle((_b3 = thumbnailMediaElements == null ? void 0 : thumbnailMediaElements.find((img) => img.mediaId === item.mediaId)) == null ? void 0 : _b3.element)) == null ? void 0 : _c2.display) !== "none" || atlasVisibleMediaIds.has(item.mediaId)) && item.media;
      }
    )) == null ? void 0 : _a2.filter((a, i, arr) => arr.findIndex((b) => b.mediaId === a.mediaId) === i)) == null ? void 0 : _b2.map((item) => {
      const renderedImage = item.element?.querySelector("img");
      const candidateRenderedSrc = renderedImage?.currentSrc || renderedImage?.src || "";
      const renderedSrc = candidateRenderedSrc && !candidateRenderedSrc.startsWith("data:image/svg+xml")
        ? candidateRenderedSrc
        : item.media?.src;
      return {
        ...item.media,
        id: item.mediaId,
        src: renderedSrc,
        alt: renderedImage?.alt || item.media?.alt || "Atlas product image",
        media_type: "image"
      };
    }).filter((item) => item.src);
    const canonicalMediaContentKey = /* @__PURE__ */ __name((item) => {
      const alt = `${item?.alt || ""}`.trim().toLowerCase();
      if (alt.includes("real ingredients compared") || alt.includes("dark chocolate almond atlas bar with almonds")) {
        return "atlas-gallery-role:made-real";
      }
      const rawSrc = `${item?.src || ""}`;
      try {
        const url = new URL(rawSrc.startsWith("//") ? `https:${rawSrc}` : rawSrc, window.location.origin);
        return `${url.origin}${url.pathname.replace(/_\d+x\d*(?=\.[a-z0-9]+$)/i, "")}`;
      } catch {
        return rawSrc.split("?")[0].replace(/_\d+x\d*(?=\.[a-z0-9]+$)/i, "");
      }
    }, "canonicalMediaContentKey");
    const selectedContentKey = canonicalMediaContentKey(rawMediaItems.find((item) => item.id === mediaId));
    const seenMediaContent = /* @__PURE__ */ new Set();
    const mediaItems = rawMediaItems.filter((item) => {
      const contentKey = canonicalMediaContentKey(item);
      if (seenMediaContent.has(contentKey)) return false;
      seenMediaContent.add(contentKey);
      return true;
    });
    const index = mediaItems.findIndex(
      (item) => item.id === mediaId || canonicalMediaContentKey(item) === selectedContentKey
    );
    if (!mediaItems.length || index < 0) return;
    if (!document.querySelector('[data-modal-id="media-gallery--vertical-gallery"]')) {
      showAtlasImageZoom(mediaItems, index);
      return;
    }
    _stores.mediaGallery.showGallery({
      media: mediaItems,
      index
    });
  }, "showMediaGallery");
  const truncateChildren = /* @__PURE__ */ __name((element, container, reCalculate = false) => {
    var _a2, _b2;
    const children = [...container.children];
    if (((_a2 = children.at(-2)) == null ? void 0 : _a2.offsetLeft) + ((_b2 = children.at(-2)) == null ? void 0 : _b2.clientWidth) < container.clientWidth) {
      return children.length - 1;
    }
    if (container.clientWidth === 0) {
      return container.children.length;
    }
    return children.findIndex(
      (childElement) => childElement.offsetLeft + childElement.clientWidth + element.clientWidth + +getComputedStyle(container).gap.replace("px", "") + 15 > container.clientWidth
    ) - 1;
  }, "truncateChildren");
  const hasAvailableVariant = /* @__PURE__ */ __name((index, value) => {
    var _a2, _b2;
    return (_b2 = (_a2 = state == null ? void 0 : state.product) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.some((variant) => {
      switch (index) {
        case 0: {
          return variant.options[index] === value && variant.available;
        }
        case 1: {
          return variant.options[0] === (state == null ? void 0 : state.options[0]) && variant.options[index] === value && variant.available;
        }
        case 2: {
          return variant.options[0] === (state == null ? void 0 : state.options[0]) && variant.options[1] === (state == null ? void 0 : state.options[1]) && variant.options[index] === value && variant.available;
        }
      }
      return false;
    });
  }, "hasAvailableVariant");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  const getDiscountLabel = /* @__PURE__ */ __name((type) => {
    var _a2, _b2, _c2, _d2, _e2;
    const price = (_b2 = (_a2 = state.selected_variant) == null ? void 0 : _a2.price) != null ? _b2 : 0;
    const compare_at_price = (_d2 = (_c2 = state.selected_variant) == null ? void 0 : _c2.compare_at_price) != null ? _d2 : 0;
    if (compare_at_price <= price) {
      return "";
    }
    switch (type) {
      case "sale": {
        return "On Sale";
      }
      case "percentage": {
        return `${Math.round((compare_at_price - price) * 100 / compare_at_price)}% off`;
      }
      case "value": {
        return `Save ${utils.formatMoney(
          compare_at_price - price,
          (_e2 = window == null ? void 0 : window.money_format) == null ? void 0 : _e2.replace(/\{(\s*)amount(\s*)}/gi, "{$1amount_no_decimals$2}")
        )}`;
      }
      default: {
        return "";
      }
    }
  }, "getDiscountLabel");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  }, "getDynamicText");
  const getDynamicValueWithFallbacks = /* @__PURE__ */ __name((content) => {
    var _a2;
    return (_a2 = content.split(",")) == null ? void 0 : _a2.reduce((acc, item) => {
      acc || (acc = utils.getBracketInputDynamicValue(item.trim(), state));
      return acc;
    }, "");
  }, "getDynamicValueWithFallbacks");
  const hideIfEmpty = /* @__PURE__ */ __name((element, hide_if_empty, isEmpty = false) => {
    var _a2, _b2;
    switch (hide_if_empty) {
      case "none":
        break;
      case "section":
        (_a2 = element.closest(`.shopify-section`)) == null ? void 0 : _a2.classList.toggle("!hidden", isEmpty);
        break;
      case "container":
        (_b2 = element.closest(`[data-style-id]:not([data-style-id="${element.getAttribute("data-style-id")}"])`)) == null ? void 0 : _b2.classList.toggle("!hidden", isEmpty);
        break;
      case "block":
        break;
    }
  }, "hideIfEmpty");
  const setDynamicPrice = /* @__PURE__ */ __name(({
    discount = state.manual_discount,
    selected_variant: selected_variant2 = state.selected_variant,
    selling_plan = state.selected_selling_plan
  }) => {
    var _a2, _b2, _c2;
    let discounted_price2 = selected_variant2 == null ? void 0 : selected_variant2.price;
    const price_adjustment2 = (_a2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _a2[0];
    if ((price_adjustment2 == null ? void 0 : price_adjustment2.value_type) === "fixed_amount") {
      discounted_price2 = Math.max(discounted_price2 - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value)), 0);
    }
    if ((price_adjustment2 == null ? void 0 : price_adjustment2.value_type) === "percentage") {
      discounted_price2 = Math.max(discounted_price2 - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value) / 100 * discounted_price2), 0);
    }
    if (discount) {
      discounted_price2 = Math.max(discounted_price2 - Math.round(discount / 100 * discounted_price2), 0);
    }
    let upsell_price_total = 0;
    let upsell_compare_at_price_total = 0;
    let upsell_triggered_quantity_limit = 9999999;
    state.upsell_items.forEach((value) => {
      var _a3, _b3, _c3, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2;
      let upsell_d_price = (_a3 = value == null ? void 0 : value.variant) == null ? void 0 : _a3.price;
      if (state.selected_selling_plan) {
        const upsell_price_adjustment = (_f2 = (_e2 = (_d2 = (_c3 = (_b3 = value == null ? void 0 : value.variant) == null ? void 0 : _b3.selling_plan_allocations) == null ? void 0 : _c3.find(
          (plan) => plan.selling_plan.id === state.selected_selling_plan.id
        )) == null ? void 0 : _d2.selling_plan) == null ? void 0 : _e2.price_adjustments) == null ? void 0 : _f2[0];
        if ((upsell_price_adjustment == null ? void 0 : upsell_price_adjustment.value_type) === "fixed_amount") {
          upsell_d_price = Math.max(upsell_d_price - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value)), 0);
        }
        if ((upsell_price_adjustment == null ? void 0 : upsell_price_adjustment.value_type) === "percentage") {
          upsell_d_price = Math.max(upsell_d_price - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value) / 100 * discounted_price2), 0);
        }
      }
      const upsell_available_quantity = ((_g2 = value == null ? void 0 : value.variant) == null ? void 0 : _g2.inventory_management) === "shopify" && ((_h2 = value == null ? void 0 : value.variant) == null ? void 0 : _h2.inventory_policy) === "deny" ? ((_i2 = value == null ? void 0 : value.variant) == null ? void 0 : _i2.inventory_quantity) - ((_k2 = (_j2 = cart == null ? void 0 : cart.state) == null ? void 0 : _j2.items) == null ? void 0 : _k2.reduce((acc, line) => line.variant_id === selected_variant2.id ? acc + line.quantity : acc, 0)) : 999999;
      const maxMultiplier = Math.floor(upsell_available_quantity / value.quantity);
      upsell_triggered_quantity_limit = Math.min(upsell_triggered_quantity_limit, maxMultiplier);
      upsell_price_total += upsell_d_price * value.quantity;
      upsell_compare_at_price_total += Math.max((_l2 = value == null ? void 0 : value.variant) == null ? void 0 : _l2.compare_at_price, (_m2 = value == null ? void 0 : value.variant) == null ? void 0 : _m2.price) * value.quantity;
    });
    state.quantity = Math.max(1, Math.min(state.quantity, state.available_quantity, upsell_triggered_quantity_limit));
    state.quantity_limit = Math.min(state.available_quantity, upsell_triggered_quantity_limit);
    state.upsell_total = upsell_price_total * state.quantity;
    state.upsell_compare_at_total = upsell_compare_at_price_total * state.quantity;
    state.selected_price = discounted_price2;
    state.selected_compare_at_price = Math.max(selected_variant2 == null ? void 0 : selected_variant2.compare_at_price, selected_variant2 == null ? void 0 : selected_variant2.price);
    if (discount !== state.manual_discount) {
      state.manual_discount = discount;
    }
    if ((selling_plan == null ? void 0 : selling_plan.id) !== ((_b2 = state == null ? void 0 : state.selected_selling_plan) == null ? void 0 : _b2.id)) {
      setSellingPlan(selling_plan == null ? void 0 : selling_plan.id);
    }
    if ((selected_variant2 == null ? void 0 : selected_variant2.id) !== ((_c2 = state == null ? void 0 : state.selected_variant) == null ? void 0 : _c2.id)) {
      setSelectedVariant(selected_variant2 == null ? void 0 : selected_variant2.id);
    }
  }, "setDynamicPrice");
  _product.getHydratedProductData(product.handle, product.id).then((res) => {
    var _a2, _b2, _c2;
    state.product = state.product.handle === res.handle ? res : state.product;
    state.selected_variant = (_c2 = (_b2 = (_a2 = state.product) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.find((variant) => {
      var _a3;
      return variant.id === ((_a3 = state.selected_variant) == null ? void 0 : _a3.id);
    })) != null ? _c2 : state.selected_variant;
  });
  handleStickyScroll();
  Alpine.effect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2, _q2, _r2, _s2, _t2, _u2, _v2, _w2, _x2, _y2, _z2, _A2, _B2, _C2;
    state.isPrimary = !isProductBar && new RegExp(`^/products/${productHandle}`, "gi").test((_a2 = _stores == null ? void 0 : _stores.router) == null ? void 0 : _a2.pathname);
    if ((state == null ? void 0 : state.isPrimary) && !window.design_mode) {
      window.onpopstate = handlePopState;
      const url = new URL(window.location.href);
      const selling_plan_id = +url.searchParams.get("selling_plan") || void 0;
      const variant_id = +url.searchParams.get("variant") || void 0;
      const remove = [];
      if (!((_b2 = state.selected_variant) == null ? void 0 : _b2.id)) {
        remove.push("variant");
      }
      if (!((_c2 = state.selected_selling_plan) == null ? void 0 : _c2.id)) {
        remove.push("selling_plan");
      }
      if (((_d2 = window == null ? void 0 : window.event) == null ? void 0 : _d2.type) === "popstate") {
        return;
      }
      if (init || ((_e2 = window == null ? void 0 : window.event) == null ? void 0 : _e2.barba_redirect)) {
        if ((product == null ? void 0 : product.handle) !== ((_f2 = state == null ? void 0 : state.product) == null ? void 0 : _f2.handle)) {
          state.product = product;
          state.upsell_items = /* @__PURE__ */ new Map();
        }
        if (variant_id !== ((_g2 = state.selected_variant) == null ? void 0 : _g2.id)) {
          state.selected_variant = ((_h2 = product == null ? void 0 : product.variants) == null ? void 0 : _h2.find((v) => v.id === variant_id)) || ((_i2 = product == null ? void 0 : product.variants) == null ? void 0 : _i2.find(
            (v) => {
              var _a3;
              return v.id && ((_a3 = product.options_with_values) == null ? void 0 : _a3.every(
                (option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]
              ));
            }
          )) || ((_j2 = product == null ? void 0 : product.variants) == null ? void 0 : _j2.find(
            (v) => {
              var _a3;
              return v.id && ((_a3 = product.options_with_values.slice(0, product.options_with_values.length - 1)) == null ? void 0 : _a3.every((option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]));
            }
          )) || (product.options_with_values.length >= 3 ? (_k2 = product == null ? void 0 : product.variants) == null ? void 0 : _k2.find(
            (v) => {
              var _a3;
              return v.id && ((_a3 = product.options_with_values.slice(0, product.options_with_values.length - 2)) == null ? void 0 : _a3.every((option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]));
            }
          ) : null) || ((_l2 = product == null ? void 0 : product.variants) == null ? void 0 : _l2.find(
            (v) => {
              var _a3;
              return v.id && ((_a3 = product.options_with_values) == null ? void 0 : _a3.some(
                (option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]
              ));
            }
          )) || ((_m2 = product == null ? void 0 : product.variants) == null ? void 0 : _m2.find((v) => v.id === product.selected_or_first_available_variant_id)) || ((_n2 = product == null ? void 0 : product.variants) == null ? void 0 : _n2[0]);
          state.selected_media_id = (_p2 = (_o2 = product == null ? void 0 : product.media) == null ? void 0 : _o2[0]) == null ? void 0 : _p2.id;
          state.properties = {};
          state.selling_plan_allocations = selling_plan_allocations;
          let discounted_price2 = (_q2 = state.selected_variant) == null ? void 0 : _q2.price;
          const price_adjustment2 = (_s2 = (_r2 = state.selected_selling_plan) == null ? void 0 : _r2.price_adjustments) == null ? void 0 : _s2[0];
          if ((price_adjustment2 == null ? void 0 : price_adjustment2.value_type) === "fixed_amount") {
            discounted_price2 = Math.max(discounted_price2 - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value)), 0);
          }
          if ((price_adjustment2 == null ? void 0 : price_adjustment2.value_type) === "percentage") {
            discounted_price2 = Math.max(discounted_price2 - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value) / 100 * discounted_price2), 0);
          }
          if (state.manual_discount) {
            discounted_price2 = Math.max(discounted_price2 - Math.round(state.manual_discount / 100 * discounted_price2), 0);
          }
          let upsell_price_total = 0;
          let upsell_compare_at_price_total = 0;
          let upsell_triggered_quantity_limit = 9999999;
          state.upsell_items.forEach((value) => {
            var _a3, _b3, _c3, _d3, _e3, _f3, _g3, _h3, _i3, _j3, _k3, _l3, _m3;
            let upsell_d_price = (_a3 = value == null ? void 0 : value.variant) == null ? void 0 : _a3.price;
            if (state.selected_selling_plan) {
              const upsell_price_adjustment = (_f3 = (_e3 = (_d3 = (_c3 = (_b3 = value == null ? void 0 : value.variant) == null ? void 0 : _b3.selling_plan_allocations) == null ? void 0 : _c3.find(
                (plan) => plan.selling_plan.id === state.selected_selling_plan.id
              )) == null ? void 0 : _d3.selling_plan) == null ? void 0 : _e3.price_adjustments) == null ? void 0 : _f3[0];
              if ((upsell_price_adjustment == null ? void 0 : upsell_price_adjustment.value_type) === "fixed_amount") {
                upsell_d_price = Math.max(upsell_d_price - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value)), 0);
              }
              if ((upsell_price_adjustment == null ? void 0 : upsell_price_adjustment.value_type) === "percentage") {
                upsell_d_price = Math.max(upsell_d_price - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value) / 100 * discounted_price2), 0);
              }
            }
            const upsell_available_quantity = ((_g3 = value == null ? void 0 : value.variant) == null ? void 0 : _g3.inventory_management) === "shopify" && ((_h3 = value == null ? void 0 : value.variant) == null ? void 0 : _h3.inventory_policy) === "deny" ? ((_i3 = value == null ? void 0 : value.variant) == null ? void 0 : _i3.inventory_quantity) - ((_k3 = (_j3 = cart == null ? void 0 : cart.state) == null ? void 0 : _j3.items) == null ? void 0 : _k3.reduce(
              (acc, line) => line.variant_id === selected_variant.id ? acc + line.quantity : acc,
              0
            )) : 999999;
            const maxMultiplier = Math.floor(upsell_available_quantity / value.quantity);
            upsell_triggered_quantity_limit = Math.min(upsell_triggered_quantity_limit, maxMultiplier);
            upsell_price_total += upsell_d_price * value.quantity;
            upsell_compare_at_price_total += Math.max((_l3 = value == null ? void 0 : value.variant) == null ? void 0 : _l3.compare_at_price, (_m3 = value == null ? void 0 : value.variant) == null ? void 0 : _m3.price) * value.quantity;
          });
          state.quantity = Math.max(1, Math.min(state.quantity, state.available_quantity, upsell_triggered_quantity_limit));
          state.quantity_limit = Math.min(state.available_quantity, upsell_triggered_quantity_limit);
          state.upsell_total = upsell_price_total * state.quantity;
          state.upsell_compare_at_total = upsell_compare_at_price_total * state.quantity;
          state.selected_price = discounted_price2;
          state.selected_compare_at_price = Math.max((_t2 = state.selected_variant) == null ? void 0 : _t2.compare_at_price, (_u2 = state.selected_variant) == null ? void 0 : _u2.price);
          state.dynamic_buy_button = null;
          state.options = (_v2 = state.selected_variant) == null ? void 0 : _v2.options;
        }
        if (selling_plan_id !== ((_w2 = state.selected_selling_plan) == null ? void 0 : _w2.id)) {
          state.selected_selling_plan = (_y2 = (_x2 = state.selected_variant.selling_plan_allocations) == null ? void 0 : _x2.find(
            (plan) => plan.selling_plan_id === selling_plan_id
          )) == null ? void 0 : _y2.selling_plan;
        }
        return;
      }
      if (selling_plan_id !== ((_z2 = state.selected_selling_plan) == null ? void 0 : _z2.id) || variant_id !== ((_A2 = state.selected_variant) == null ? void 0 : _A2.id)) {
        url.searchParams.set("selling_plan", `${(_B2 = state.selected_selling_plan) == null ? void 0 : _B2.id}`);
        url.searchParams.set("variant", `${(_C2 = state.selected_variant) == null ? void 0 : _C2.id}`);
        remove.forEach((key) => {
          url.searchParams.delete(key);
        });
        window.history.replaceState(window.history.state, "", url.toString());
      }
    }
  });
  Alpine.effect(() => {
    var _a2, _b2, _c2;
    if (state.dynamic_buy_button) {
      state.dynamic_buy_button.disabled = !((_a2 = state.selected_variant) == null ? void 0 : _a2.available);
      if (!((_b2 = state.dynamic_buy_button) == null ? void 0 : _b2.hasAttribute("data-no-out-of-stock"))) {
        state.dynamic_buy_button.classList.toggle("dynamic-buy-button-out-of-stock", !((_c2 = state.selected_variant) == null ? void 0 : _c2.available));
      }
    }
  });
  Alpine.effect(() => {
    var _a2;
    if (quickView) {
      (_a2 = Shopify == null ? void 0 : Shopify.PaymentButton) == null ? void 0 : _a2.init();
      handleImageSelection(gallerySettings == null ? void 0 : gallerySettings.filter_images, mediaElements, state.selected_variant);
      if (thumbnailSettings) {
        handleImageSelection(thumbnailSettings == null ? void 0 : thumbnailSettings.thumbnail_filter_images, thumbnailMediaElements, state.selected_variant);
      }
      syncAtlasMediaLayout();
      return;
    }
    handleImageSelection(gallerySettings == null ? void 0 : gallerySettings.filter_images, mediaElements, state.selected_variant);
    if (thumbnailSettings) {
      handleImageSelection(thumbnailSettings == null ? void 0 : thumbnailSettings.thumbnail_filter_images, thumbnailMediaElements, state.selected_variant);
    }
    syncAtlasMediaLayout();
  });
  Alpine.effect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2;
    let discounted_price2 = (_a2 = state.selected_variant) == null ? void 0 : _a2.price;
    const price_adjustment2 = (_c2 = (_b2 = state.selected_selling_plan) == null ? void 0 : _b2.price_adjustments) == null ? void 0 : _c2[0];
    const product2 = state.product;
    const selected_variant2 = state.selected_variant;
    state.hasVariants = ((_d2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _d2.length) > 1 || ((_f2 = (_e2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _e2[0]) == null ? void 0 : _f2.title) !== "Default Title";
    state.hasSubscription = !!((_g2 = selected_variant2 == null ? void 0 : selected_variant2.options) == null ? void 0 : _g2.length);
    state.available_quantity = (selected_variant2 == null ? void 0 : selected_variant2.inventory_management) === "shopify" && (selected_variant2 == null ? void 0 : selected_variant2.inventory_policy) === "deny" ? (selected_variant2 == null ? void 0 : selected_variant2.inventory_quantity) - ((_i2 = (_h2 = cart == null ? void 0 : cart.state) == null ? void 0 : _h2.items) == null ? void 0 : _i2.reduce((acc, line) => line.variant_id === selected_variant2.id ? acc + line.quantity : acc, 0)) : (selected_variant2 == null ? void 0 : selected_variant2.preorder) && (selected_variant2 == null ? void 0 : selected_variant2.preorder_quantity) ? (selected_variant2 == null ? void 0 : selected_variant2.inventory_quantity) + (selected_variant2 == null ? void 0 : selected_variant2.preorder_quantity) - ((_k2 = (_j2 = cart == null ? void 0 : cart.state) == null ? void 0 : _j2.items) == null ? void 0 : _k2.reduce((acc, line) => line.variant_id === selected_variant2.id ? acc + line.quantity : acc, 0)) : 99999;
    state.soldOut = state.available_quantity <= 0;
    state.preorder = (selected_variant2 == null ? void 0 : selected_variant2.preorder) && (selected_variant2 == null ? void 0 : selected_variant2.inventory_quantity) - ((_m2 = (_l2 = cart == null ? void 0 : cart.state) == null ? void 0 : _l2.items) == null ? void 0 : _m2.reduce((acc, line) => line.variant_id === selected_variant2.id ? acc + line.quantity : acc, 0)) < preorder_threshold;
    if ((price_adjustment2 == null ? void 0 : price_adjustment2.value_type) === "fixed_amount") {
      discounted_price2 = Math.max(discounted_price2 - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value)), 0);
    }
    if ((price_adjustment2 == null ? void 0 : price_adjustment2.value_type) === "percentage") {
      discounted_price2 = Math.max(discounted_price2 - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value) / 100 * discounted_price2), 0);
    }
    if (state.manual_discount) {
      discounted_price2 = Math.max(discounted_price2 - Math.round(state.manual_discount / 100 * discounted_price2), 0);
    }
    let upsell_price_total = 0;
    let upsell_compare_at_price_total = 0;
    let upsell_triggered_quantity_limit = 9999999;
    state.upsell_items.forEach((value) => {
      var _a3, _b3, _c3, _d3, _e3, _f3, _g3, _h3, _i3, _j3, _k3, _l3, _m3, _n3, _o3, _p2, _q2, _r2, _s2;
      let upsell_d_price = (_a3 = value == null ? void 0 : value.variant) == null ? void 0 : _a3.price;
      if (state.selected_selling_plan) {
        const upsell_price_adjustment = (_f3 = (_e3 = (_d3 = (_c3 = (_b3 = value == null ? void 0 : value.variant) == null ? void 0 : _b3.selling_plan_allocations) == null ? void 0 : _c3.find(
          (plan) => plan.selling_plan.id === state.selected_selling_plan.id
        )) == null ? void 0 : _d3.selling_plan) == null ? void 0 : _e3.price_adjustments) == null ? void 0 : _f3[0];
        if ((upsell_price_adjustment == null ? void 0 : upsell_price_adjustment.value_type) === "fixed_amount") {
          upsell_d_price = Math.max(upsell_d_price - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value)), 0);
        }
        if ((upsell_price_adjustment == null ? void 0 : upsell_price_adjustment.value_type) === "percentage") {
          upsell_d_price = Math.max(upsell_d_price - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value) / 100 * discounted_price2), 0);
        }
      }
      const upsell_available_quantity = ((_g3 = value == null ? void 0 : value.variant) == null ? void 0 : _g3.inventory_management) === "shopify" && ((_h3 = value == null ? void 0 : value.variant) == null ? void 0 : _h3.inventory_policy) === "deny" ? ((_i3 = value == null ? void 0 : value.variant) == null ? void 0 : _i3.inventory_quantity) - ((_k3 = (_j3 = cart == null ? void 0 : cart.state) == null ? void 0 : _j3.items) == null ? void 0 : _k3.reduce((acc, line) => line.variant_id === selected_variant2.id ? acc + line.quantity : acc, 0)) : ((_l3 = value.variant) == null ? void 0 : _l3.preorder) && ((_m3 = value.variant) == null ? void 0 : _m3.preorder_quantity) ? ((_n3 = value.variant) == null ? void 0 : _n3.inventory_quantity) + ((_o3 = value.variant) == null ? void 0 : _o3.preorder_quantity) - ((_q2 = (_p2 = cart == null ? void 0 : cart.state) == null ? void 0 : _p2.items) == null ? void 0 : _q2.reduce((acc, line) => line.variant_id === value.variant.id ? acc + line.quantity : acc, 0)) : 99999;
      const maxMultiplier = Math.floor(upsell_available_quantity / value.quantity);
      upsell_triggered_quantity_limit = Math.min(upsell_triggered_quantity_limit, maxMultiplier);
      upsell_price_total += upsell_d_price * value.quantity;
      upsell_compare_at_price_total += Math.max((_r2 = value == null ? void 0 : value.variant) == null ? void 0 : _r2.compare_at_price, (_s2 = value == null ? void 0 : value.variant) == null ? void 0 : _s2.price) * value.quantity;
    });
    state.quantity = Math.max(1, Math.min(state.quantity, state.available_quantity, upsell_triggered_quantity_limit));
    state.quantity_limit = Math.min(state.available_quantity, upsell_triggered_quantity_limit);
    state.upsell_total = upsell_price_total * state.quantity;
    state.upsell_compare_at_total = upsell_compare_at_price_total * state.quantity;
    state.selected_price = discounted_price2;
    state.selected_compare_at_price = Math.max((_n2 = state.selected_variant) == null ? void 0 : _n2.compare_at_price, (_o2 = state.selected_variant) == null ? void 0 : _o2.price);
  });
  const mutationObserver = new MutationObserver((e) => {
    e == null ? void 0 : e.forEach((record) => {
      var _a2;
      const nodes = [];
      (_a2 = record == null ? void 0 : record.addedNodes) == null ? void 0 : _a2.forEach((node) => {
        if (node instanceof HTMLInputElement && (node == null ? void 0 : node.tagName) === "INPUT" && node.name === "selling_plan" && node.value) {
          setSellingPlan(+node.value);
        }
      });
    });
  });
  mutationObserver.observe($formEl, { childList: true, subtree: true });
  if (state.isPrimary) {
    Alpine.store("main_product", {
      state,
      settings,
      handleAddToCart,
      handleBackInStockNotification,
      styleDynamicBuyButton,
      setSelectedVariant,
      setProductOption,
      setSiblingProduct,
      setSellingPlan,
      setQuantity,
      handleStickyScroll,
      scrollToMediaById,
      showMediaGallery,
      truncateChildren,
      renderProductCards,
      hasAvailableVariant,
      getContentLabels,
      getDiscountLabel,
      getDynamicText,
      getDynamicValueWithFallbacks,
      hideIfEmpty
    });
    const main_product = Alpine.store("main_product");
    Alpine.magic("main_product", () => main_product);
    window._stores["main_product"] = main_product;
  }
  init = false;
  return {
    pdp: state,
    settings,
    handleAddToCart,
    handleBackInStockNotification,
    styleDynamicBuyButton,
    setSelectedVariant,
    setProductOption,
    setSiblingProduct,
    setSellingPlan,
    setQuantity,
    handleStickyScroll,
    scrollToMediaById,
    showMediaGallery,
    truncateChildren,
    renderProductCards,
    hasAvailableVariant,
    getContentLabels,
    getDiscountLabel,
    getDynamicText,
    getDynamicValueWithFallbacks,
    setDynamicPrice,
    hideIfEmpty
  };
}, "initMainProduct");
window._sections["initMainProduct"] = initMainProduct;
// Atlas gallery mapping revision: 2026-08-14-dca.
